import { useEffect, useState } from "react";
import StorylineServerProxy  from "../storyline-proxy/storyline-proxy"
import { Box, Button, Grid, Link, Modal, Paper } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import IconDelete from '@mui/icons-material/Delete';
import TEDDetails from "./TED-details";
import { formatTEDDate } from "./TED-details";
import { DateHeader } from "../GeneralComponents/date-header";

export default function PendingTEDsList ({showProcessedTEDs}){
    const [TEDs, setTEDs] = useState([] as any[]); 
    const [selectedTED, setSelectedTED] = useState(null as any);

    const [detailsOpen, setDetailsOpen]  = useState(false);

    const [showProcessed, setShowProcessed] = useState(showProcessedTEDs);

    function handleShowDetails(ted){
        setSelectedTED(ted);
        setDetailsOpen(true);
    }

    function handleCloseDetails(){
        setDetailsOpen(false);
    }

    function loadFromServer(){
        const sortFunction = (a, b) => {return a.date > b.date  ? -1 : 1};
        if(showProcessed){
            StorylineServerProxy.processedTEDs().then(TEDs => { 
                setTEDs(TEDs.TEDs.sort(sortFunction))});
        }
        else{
            StorylineServerProxy.pendingTEDs().then(TEDs => {
                setTEDs(TEDs.TEDs.sort(sortFunction))});

        }
    }

    useEffect(() => {
        loadFromServer();
    }, [showProcessed])

    function handleCloseAndDelete(ted){
        handleCloseDetails();
        handleDeleteClicked(ted);
    }

    function handleDeleteClicked(ted){
        if(showProcessed){
            StorylineServerProxy.deleteProcessedTED(ted).then(() => { loadFromServer() });
        }
        else{
            StorylineServerProxy.deletePendingTED(ted).then(() => { loadFromServer() });
        }
    }

    function handlePurgeListClicked(){
        StorylineServerProxy.deleteAllProcessedTED().then(() => { loadFromServer() });
    }


    return (
        <>
            <Modal sx={{ left: 100, top: 100, width:9/10, }} open={detailsOpen} onClose={handleCloseDetails}>
                <Paper elevation={6} sx={{padding: 2}}>
                    <TEDDetails ted={selectedTED} handleCloseAndDelete={handleCloseAndDelete} handleClose={handleCloseDetails}/>
                </Paper>
            </Modal>
            {
                TEDs.map((TED, index) => {
                    const dateString = /*formatTEDDate*/(TED.date);
                    const prevDateString = index != 0 ? /*formatTEDDate*/(TEDs[index - 1].date) : "";

                    return (
                        <>
                            <DateHeader prevDateString={prevDateString} dateString={dateString}/>
                            <Paper elevation={6} sx={{ padding: 2}}>
                                <Grid container>
                                    <Grid item xs={11}>
                                        <Link onClick={() => { handleShowDetails(TED) }}>
                                            { TED.title }
                                        </Link>
                                        <br/>
                                        { TED.type } 
                                        {
                                            TED.matchedBy?<>
                                                <br />
                                                { TED.matchedBy.matchingFunction } { TED.matchedBy.parameter }
                                            </>:<></>
                                        }
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Paper>
                                            <Link href={ TED.link } target="child"><OpenInNewIcon /></Link>
                                            &nbsp;
                                            <IconDelete onClick={() => { handleDeleteClicked(TED) }} />
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </>
                    )
                })
            }

            { showProcessed?<Paper elevation={4} sx={{padding: 4}}><Button onClick={ handlePurgeListClicked }>Purge list</Button></Paper>:<></> }

        </>
    )
}